var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:_vm.baseClass},[_c('div',{staticClass:"bubble bubble-4"}),_c('div',{staticClass:"bubble bubble-3"}),_c('div',{staticClass:"bubble bubble-2"}),_c('div',{staticClass:"bubble bubble-1"}),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }